import { toggleFollowSlug, syncFollows as syncFollowsLocal, pushFollow } from '../follows';

export const actions = {
    fetchInfo({commit}) {
        const store = this;
        return axios.get(API_BASE_URL + '/info', { params: { _fresh: Date.now() } })
            .then(res => {
                commit('FETCH_INFO', res.data['info']);
            }).catch(err => {
                console.log(err);
            });
    },
    fetchComics({commit}, path) {
        const store = this;
        // Always refresh the catalogue; admin edits can happen in another tab.
        const loader = $('#loader');
        loader.show();
        return axios.get(API_BASE_URL + path, { params: { _fresh: Date.now() } })
            .then(res => {
                commit('FETCH_COMICS', res.data['comics']);
            }).catch(err => {
                console.log(err);
            }).finally(
                () => loader.hide()
            );
    },
    fetchLatestChapters({commit}) {
        const store = this;

        return axios.get(API_BASE_URL + '/latest-chapters', { params: { _fresh: Date.now() } })
            .then(res => commit('FETCH_LATEST_CHAPTERS', res.data['chapters']))
            .catch(err => console.log(err));
    },
    fetchComic({commit}, route) {
        const store = this;
        const loader = $('#loader');
        loader.show();
        return axios.get(API_BASE_URL + route.path, { params: { licensed: true, _fresh: Date.now() } })
            .then(res => {
                commit('FETCH_COMIC', res.data['comic']);
            }).catch(err => {
                console.log(err);
            }).finally(
                () => loader.hide()
            );
    },
    fetchChapter({commit}, path) {
        const store = this;
        const comic = store.getters.comic;
        const loader = $('#loader');
        loader.show();
        return axios.get(API_BASE_URL + path, { params: { _fresh: Date.now() } })
            .then(res => {
                commit('FETCH_COMIC', res.data['comic']);
                commit('FETCH_CHAPTER', res.data['chapter']);
            }).catch(err => {
                console.log(err);
            }).finally(
                () => loader.hide()
            );
    },
    fetchRating({commit}, slug) {
        if (!slug) return;
        return axios.get(`${API_BASE_URL}/rating/${slug}`)
            .then(res => {
                commit('SET_RATING', {...res.data, slug});
            }).catch(err => {
                console.log(err);
            });
    },
    sendRating({commit, state}, {slug, vote}) {
        return axios.post(`${API_BASE_URL}/rating/${slug}`, {vote: vote, vote_token: state.vote_token})
            .then(res => {
                commit('SET_RATING', {...res.data, slug});
            });
    },
    toggleFollow({commit}, slug) {
        if (!slug) return;
        const followed = toggleFollowSlug(slug);
        pushFollow(slug, followed);
        commit('TOGGLE_FOLLOW', slug);
    },
    syncFollows({commit}) {
        return syncFollowsLocal().then(list => {
            if (Array.isArray(list)) commit('SET_FOLLOWS', list);
        });
    }
}
